// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".btn[data-v-fd9d97d2]{background:#ff0;display:inline-block}", "",{"version":3,"sources":["/apps/jenkins/www/workspace/招商平台-huawei-prod/src/views/attractPlatform/regionPersonal/search.vue"],"names":[],"mappings":"AACA,sBACE,eAAA,CACA,oBAAA","file":"search.vue","sourcesContent":["\n.btn{\n  background:yellow;\n  display: inline-block;\n  // width:20%;\n}\n"]}]);
// Exports
module.exports = exports;
